import { createAction } from 'redux-actions'

export const debugModeOn = createAction('DEBUG_MODE_ON')
export const debugModeOff = createAction('DEBUG_MODE_OFF')
